<template>
  <m-labeled-text
    :label="label"
    :horizontal="horizontal"
    :label-width="labelWidth"
    :helper="helper"
    :instructions="instructions"
  >
    <template v-if="$slots.helper" #helper> <slot name="helper" /></template>
    <template #text>
      <div class="button-toggle" role="group">
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="button-toggle__btn"
          :class="{ 'button-toggle__btn--active': templateValue === option.value }"
          @click="select(option.value)"
        >
          {{ option.label }}
        </button>
      </div>
    </template>
  </m-labeled-text>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useFormValue } from "../../../../composables/namedValue";
import MLabeledText from "../../MLabeledText";

export default defineComponent({
  components: { MLabeledText },
  props: {
    modelValue: [Object, String, Number],
    name: String,

    options: {
      type: Array,
      default() {
        return [];
      },
    },

    label: String,

    horizontal: {
      type: Boolean,
      default: undefined,
    },
    labelWidth: String,

    helper: String,
    instructions: String,
  },
  setup(props) {
    const templateValue = useFormValue(props);

    function select(value: unknown) {
      templateValue.value = value;
    }

    return {
      templateValue,
      select,
    };
  },
});
</script>

<style lang="scss">
.button-toggle {
  box-shadow: none;
  background: #ffffff;
  border-radius: 4px;
  display: inline-flex;
  overflow: hidden;

  &__btn {
    height: 36px;
    padding: 0 16px;
    border-top: 1px solid #c1c6cd;
    border-bottom: 1px solid #c1c6cd;
    border-right: 1px solid #c1c6cd;
    border-left: none;
    background: white;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: var(--text-color);

    &:first-child {
      border-left: 1px solid #c1c6cd;
    }

    &--active {
      background: var(--grey-light) !important;
    }
  }
}
</style>
